<template>
    <v-container fluid :style="{background: $store.getters.getColorPalette().backgroundColorCode}">
        <InfoAlert :showDismissibleAlert="showDismissibleAlert" :info="info" v-on:close="showDismissibleAlert=false" />
        <v-divider></v-divider>
            
        <v-row v-if="$store.state.user && $store.state.settingMode && $store.getters.getAccessByLevels(['betaaccess']) ">
            <v-col>
       <v-chip
      class="ma-2"
      small
      outlined
      color="teal"
      text-color="green" v-for="param in report.list"
        :key="param">
        {{getParamName(param)}}
        </v-chip>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-form
    ref="usageForm"
    v-model="valid"
    
  >
        <v-row>
             <v-col>
                <v-menu
        v-model="menu1"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
     :dark="$store.getters.getColorPalette().isDark"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="form.from_date"
            :label="$store.getters.getTextMap().from_date"
            prepend-icon="mdi-calendar"
            readonly
            :loading="loading"
            v-bind="attrs"
            v-on="on"
            :rules="ISODateRules"
          :dark="$store.getters.getColorPalette().isDark"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="form.from_date"
          @input="menu1 = false"
        ></v-date-picker>
      </v-menu>
            </v-col>
            <v-col>
                <v-menu
        v-model="menu2"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
       :dark="$store.getters.getColorPalette().isDark"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="form.to_date"
            :label="$store.getters.getTextMap().to_date"
            prepend-icon="mdi-calendar"
            readonly
            :loading="loading"
            v-bind="attrs"
            v-on="on"
            :rules="ISODateRules"
          :dark="$store.getters.getColorPalette().isDark"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="form.to_date"
          @input="menu2 = false"
         :dark="$store.getters.getColorPalette().isDark"
        ></v-date-picker>
      </v-menu>
            </v-col>
            <v-col>
                <v-skeleton-loader
        v-if="loading"
      class="mx-auto"
      type="text"
    ></v-skeleton-loader>
                <v-btn
          v-if="!loading"
            :color="$store.getters.getColorPalette().submitbtnColor"
            text
            @click="onSubmit"
          >
          {{$store.getters.getTextMap().view_report}}

          </v-btn>
            </v-col>
        </v-row>
        </v-form>
    <v-progress-circular
      indeterminate
      v-if="loading"
      color="primary"
    ></v-progress-circular>
        <v-row v-if="tableData.length>0">
            <v-col align-self="center">
                <strong>{{report.name ?report.name : report.report_id}} - {{dateRangeText}}</strong>
            
                <strong>{{report.from_date}}</strong> - <strong>{{report.to_date}}</strong>
            </v-col>
            <v-col v-if="!loading " align-self="center">
              <v-select
                v-if="!loading"
              v-model="processing"
          :items="processingOptions"
          :label="$store.getters.getTextMap().data"
          outlined
          small
          item-text="label"
          item-value="value"
          required
        :dark="$store.getters.getColorPalette().isDark"
            :rules="objectRules"
        ></v-select>
        </v-col>
            <v-col align="right">
                <v-btn-toggle
        v-if="tableData.length>0"
          v-model="graphType"
          mandatory
        >
          <v-btn small>
            {{$store.getters.getTextMap().bar}}

          </v-btn>
          <v-btn small>
            {{$store.getters.getTextMap().line}}

          </v-btn>
              </v-btn-toggle>
            </v-col>
        </v-row>
        
            
        
        <v-row>
          <v-col>
            <div ref="graph"></div>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-data-table
      :headers="headers"
      :items="tableData"
      item-key="date"
      :search="search"
      :loading="loading"
   :dark="$store.getters.getColorPalette().isDark"
    loading-text="Loading... Please wait"
    >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-toolbar-title>Usage - {{dateRangeText}}</v-toolbar-title>
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <v-spacer></v-spacer>
        <v-btn 
                v-if="tableData.length>0"
                outlined 
                small
                
                @click="downloadTable">
                Download Table
                </v-btn>
        
      </v-toolbar>
          </template>
          
          
    </v-data-table>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <a ref="csvDownload" hidden></a>
        </v-container>
</template>

<script>
//import LineGraphByTimeStamp from '@/components/graphs/LineGraphByTimeStamp'
//import BarGraphByDate from '@/components/graphs/BarGraphByDate'
//import LineGraphByDate from '@/components/graphs/LineGraphByDate'
import InfoAlert from '@/components/InfoAlert'
import axios from 'axios'
import moment from 'moment'
import Plotly from 'plotly.js'
// import jsPDF from 'jspdf'
import 'jspdf-autotable'
// import { applyPlugin } from 'jspdf-autotable'
// applyPlugin(jsPDF)

export default {
    name:'EnergyUsageReportDetails',
    props:['report'],
    components:{
        InfoAlert,
        //LineGraphByTimeStamp,
        //LineGraphByDate,
        //BarGraphByDate
    },
    mounted(){
      
        this.form['from_date']=moment().subtract(15,'d').format('YYYY-MM-DD')
        this.form['to_date']=moment().subtract(1,'d').format('YYYY-MM-DD')
        this.onSubmit()
        this.headers=[
                {
            text: 'Date',
            align: 'start',
            sortable: false,
            value: 'date',
            class:"text-subtitle-1 text-capitalize "+this.$store.getters.getColorPalette().tableHeaderColorName
          }, 
          {text:'Energy', value:this.report.energy,class: "text-subtitle-1 text-capitalize "+this.$store.getters.getColorPalette().tableHeaderColorName},
          {text:'Apparent Energy', value:this.report.apparent_energy,class:"text-subtitle-1 text-capitalize "+this.$store.getters.getColorPalette().tableHeaderColorName},
          {text:'MD', value:this.report.md,class:"text-subtitle-1 text-capitalize "+this.$store.getters.getColorPalette().tableHeaderColorName}]
    },
    data(){
        return {
            form:{
                from_date:null,
                to_date:null,
                
            },
            //date: new Date().toISOString().substr(0, 10),
            label:null,
            dateRangeText:null,
            unit:null,
                valid:false,
                menu:false,
                menu1:null,
            menu2:null,
            graphData:{},
            processing:'usage',
            graphType:0,
            showDismissibleAlert:false,
            loading:false,
            info:'',
            search:null,
            rawData:[],
            tableData:[],
            layout:{
              
              showlegend:false,
              colorway:this.$store.getters.colorTypesCodeArray,
              font:{
                         color:this.$store.getters.getColorPalette().accentCode
                        },
                    plot_bgcolor:this.$store.getters.getColorPalette().background2ColorCode,
                    paper_bgcolor:this.$store.getters.getColorPalette().background2ColorCode,
                    
                    autosize: true,
                    xaxis: {
                        tickangle: -12,
                        zeroline: false,
                        showgrid: true,
                        showticklabels: true,
                        color:this.$store.getters.getColorPalette().accentCode,
                      },       
                      yaxis: {
                        showticklabels: true,
                        color:this.$store.getters.getColorPalette().accentCode,
                      },
                      uniformtext: {
                        "mode": "hide",
                        "minsize": 1
                      }
            },
            headers:[
                {
            text: 'Date',
            align: 'start',
            sortable: false,
            value: 'date',
            class: "text-subtitle-1 text-capitalize "+this.$store.getters.getColorPalette().tableHeaderColorName
          },
          {text:'Energy', value:this.report.energy,class: "text-subtitle-1 text-capitalize "+this.$store.getters.getColorPalette().tableHeaderColorName},
          {text:'Apparent Energy', value:this.report.apparent_energy,class: "text-subtitle-1 text-capitalize "+this.$store.getters.getColorPalette().tableHeaderColorName},
          {text:'MD', value:this.report.md,class: "text-subtitle-1 text-capitalize "+this.$store.getters.getColorPalette().tableHeaderColorName}
            ],
            processingOptions:[
                {label:'Usage or Average',value:'usage'},
                //{label:'Standard Deviation',value:'std'},
                //{label:'Statistical Mode',value:'mode'},
                {label: 'Peak Value', value:'max'},
                {label: 'Min Value', value:'min'}
                ],
            ISODateRules:[
            v => !!v || 'Required',
            v => /[0-9][0-9][0-9][0-9]-[0-9][0-9]-[0-9][0-9]$/.test(v) || 'It should be a Date',
            ],
             objectRules:[
        v => !!v || 'Required',
      ],
        }
    },
    computed:{
        
    },
    methods:{
      downloadTable(){
        //let pdf = new jsPDF('landscape','pt',[512,600]);
            // let pdf = new jsPDF();
            //pdf.table(20, 30, this.currentData);
            let header=this.headers.map(x=>x['text'])
            let headerVal=this.headers.map(x=>x['value'])
            
            let body=[]
            for (let i of this.tableData){
                let temp=[]
                for(let j of headerVal){
                  temp.push(i[j])
                }
                
                body.push(temp)
            }
            // pdf.autoTable({
            //     head: [header],
            //     body: body
            //     })
            // pdf.save('usage.pdf');

            let csvHeader=header.join(',')+"\n"
            let csv=csvHeader
            csv+=body.map(e => e.join(",")).join("\n");
            let csvData = new Blob([csv], { type: 'text/csv' });  
            let csvUrl = URL.createObjectURL(csvData);
            //let hiddenElement = document.createElement('a');
            let hiddenElement = this.$refs.csvDownload;
            hiddenElement.href = csvUrl;
            hiddenElement.target = '_blank';
            hiddenElement.download = 'Usage.csv';
            hiddenElement.click();
      },
        getParamName(param){
          let p=this.$store.getters.getParameterById(param)
          if(p){
          return this.$store.getters.getDeviceById(p['device_id'])['name'] +"-"+p['name']
          }else{
            return "Issue with Report Param"
          }
        },
        createTable(){
          if(this.rawData && this.rawData.length>0){
            this.tableData=[]
            let temp=this.rawData.reduce((prev,current)=>{
              if(!(current.date in prev)){
                prev[current.date]={
                  date:current.date
                }
                
              }
              prev[current.date][current.param_id]=current[this.processing]
              return prev
            },{})
            
            this.tableData=Object.values(temp)
            // this.headers.push({text:'Energy', value:this.report.energy,class: "text-subtitle-1 text-capitalize indigo lighten-3 font-weight-black "})
            // this.headers.push({text:'Apparent Energy', value:this.report.apparent_energy,class: "text-subtitle-1 text-capitalize indigo lighten-3 font-weight-black "})
            // this.headers.push({text:'MD', value:this.report.md,class: "text-subtitle-1 text-capitalize indigo lighten-3 font-weight-black "})
            // this.headers[1]={text:'Energy', value:this.report.energy,class: "text-subtitle-1 text-capitalize indigo lighten-3 font-weight-black "}
            // this.headers[2]={text:'Apparent Energy', value:this.report.apparent_energy,class: "text-subtitle-1 text-capitalize indigo lighten-3 font-weight-black "}
            // this.headers[3]={text:'MD', value:this.report.md,class: "text-subtitle-1 text-capitalize indigo lighten-3 font-weight-black "}
          }
        },
        createGraph(){
        if(this.rawData && this.rawData.length>0){
            this.graphData={}
            if(!this.processing){
              this.processing='usage'
            }
            
            for (let i of this.rawData){
                //console.log(i)
                        if(i.param_id && i.param_id in this.graphData){
                            this.graphData[i.param_id]['x'].push(moment(i.date,'DD-MM-YYYY').format('YYYY-MM-DD HH:mm:ss'))
                            this.graphData[i.param_id]['y'].push(Number(i[this.processing]))
                        }else{
                          
                            let name=this.getParamName(i.param_id)
                            let type=this.graphType==1?'scatter':'bar'
                            this.graphData[i.param_id]={
                                x: [],
                                y: [],
                                name:name,
                                type: type
                            }
                            this.graphData[i.param_id]['x'].push(moment(i.date,'DD-MM-YYYY').format('YYYY-MM-DD HH:mm:ss'))
                            this.graphData[i.param_id]['y'].push(Number(i[this.processing]))
                        }
                    
                }
                //this.graphData.push(data)
                
            Plotly.newPlot(this.$refs.graph, Object.values(this.graphData), this.layout,{displaylogo: false, displayModeBar:true});
        }

      },
        onSubmit(){
            this.$refs.usageForm.validate()
            if(this.valid){
              this.loading=true
              //let fromTimeStamp=this.fromTimeStamp
              //let toTimeStamp=this.toTimeStamp
              let payload={
                  report_id:this.report.report_id,
      from_date:moment(this.form.from_date.toString(),'YYYY-MM-DD').format("YYYYMMDD"),
      to_date:moment(this.form.to_date.toString(),'YYYY-MM-DD').format("YYYYMMDD"),
      discrete:true
    }
    this.dateRangeText=moment(this.form.from_date.toString(),'YYYY-MM-DD').format("DD-MM-YYYY")+' - '+moment(this.form.to_date.toString(),'YYYY-MM-DD').format("DD-MM-YYYY")
    let endpoint='getDataByEnergyUsageReportBetweenDate'
    
    axios.post(this.$store.state.api+endpoint,payload,{headers: {
      Authorization: 'Bearer '+ this.$store.state.jwt
    }})
    .then(response=>{
      //console.log(response.data)
      if(response.data.status==='success'){
        
let data=[]
this.rawData=[]
for (let i of response.data.data){
  //i['usage']=Number(i['usage'])*Number(this.report.correction_factor)
  //console.log(i)
    data.push(i)
  let tmp=Object.assign({},i)
  tmp['date']=moment(tmp['date'].toString(),'YYYYMMDD').format("DD-MM-YYYY")
  this.rawData.push(tmp)
}
//this.graphData=data
this.createGraph()
this.createTable()
      //console.log(response.data.data)
      //this.report['parameter']=this.form.parameter
      //this.report['date']=this.form.date
      if(this.graphData.length==0){
          this.info = "No data to show";
            this.showDismissibleAlert = true;
      }

    }else{
      this.info = response.data.msg;
      //this.info = d;
            this.showDismissibleAlert = true;
      //console.log(response.data.msg)
      this.loading=false
    }
      this.loading=false

    })
    .catch(err=>{
    this.showDismissibleAlert=true
            this.info=err
            this.loading=false
            })

        }
    },
    },
    watch:{
      processing(){
        this.createGraph()
        this.createTable()
      },
      graphType(){
        this.createGraph()
      }
    }
}
</script>